<script setup lang="ts">
import { computed } from 'vue';
import { DgrIcon, IconTypes } from '@stockmarkteam/donguri-ui';

type Variant = 'focus-point' | 'hypothesis' | 'recommendation';

interface Props {
  variant: Variant;
}
const props = defineProps<Props>();

const presentations: Record<Variant, { icon: IconTypes; label: string }> = {
  'focus-point': { icon: 'eye', label: '着眼点' },
  hypothesis: { icon: 'balance', label: '仮説' },
  recommendation: { icon: 'action', label: '推奨アクション' },
};

const presentation = computed(() => presentations[props.variant]);
</script>

<template>
  <div class="c-title-bold--s tag-title" :class="variant">
    <DgrIcon :name="presentation.icon" size="small" :keep-fill="false" />
    {{ presentation.label }}
  </div>
</template>

<style lang="scss" scoped>
.tag-title {
  display: flex;
  gap: 2px;
  width: fit-content;
  padding: 4px;
  border-radius: 4px;
  justify-content: center;

  &.focus-point {
    color: $color-sb7;
    fill: $color-sb7;
    background-color: $color-sb1;
  }
  &.hypothesis {
    color: $color-pk7;
    fill: $color-pk7;
    background-color: $color-pk1;
  }
  &.recommendation {
    color: $color-green600;
    fill: $color-green600;
    background-color: $color-green100;
  }
}
</style>
